import { PortalThemeConfig } from '../models/portal-theme.state';

/**
 * Donation Portal theme -- user-facing.
 * Uses semantic variable references so it inherits base theme changes automatically.
 */
export const DONATION_THEME: PortalThemeConfig = {
  id: 'donation',
  label: 'Donation Portal',
  logoPath: 'assets/portals/donation/logo.svg',
  tokens: {
    '--portal-accent': 'var(--primary)',
    '--portal-accent-light': 'var(--primary-light)',
    '--portal-sidebar-bg': 'var(--surface)',
    '--portal-sidebar-text': 'var(--text-primary)',
    '--portal-sidebar-text-muted': 'var(--text-secondary)',
    '--portal-sidebar-section': 'var(--text-disabled)',
    '--portal-sidebar-border': 'var(--border)',
    '--portal-sidebar-active-bg': 'var(--portal-accent-light)',
    '--portal-sidebar-active-text': 'var(--portal-accent)',
    '--portal-toolbar-bg': 'var(--surface)',
    '--portal-page-bg': 'var(--bg-page)',
    '--portal-highlight': 'var(--color-purple-500)',
    '--portal-highlight-light': 'var(--color-purple-50)'
  }
};

export const PORTAL_THEMES: Record<string, PortalThemeConfig> = {
  donation: DONATION_THEME
};
